/*eslint-disable*/
import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
import classNames from "classnames";
import {List, ListItem, withStyles} from "@material-ui/core";

// @material-ui/icons
import Favorite from "@material-ui/icons/Favorite";

import footerStyle from "assets/jss/material-kit-react/components/footerStyle.jsx";
import {Dictionary} from "../../../database/dictionary";
import Button from "../../../components/CustomButtons/Button";

function Footer({...props}) {
    const {classes, whiteFont} = props;
    const footerClasses = classNames({
        [classes.footer]: true,
        [classes.footerWhiteFont]: whiteFont
    });
    const aClasses = classNames({
        [classes.a]: true,
        [classes.footerWhiteFont]: whiteFont
    });
    return (
        <footer className={footerClasses}>
            <div className={classes.container}>
                <div className={classes.left}>
                    <List className={classes.list}>
                        <ListItem className={classes.inlineBlock}>
                            <a
                                href="https://vrational.com/"
                                className={classes.block}
                                target="_blank"
                            >
                                Blog
                            </a>
                        </ListItem>
                        <ListItem className={classes.inlineBlock}>
                            <Button justIcon link
                                    href={Dictionary.twitter}
                                    target="_blank"
                                    className={classes.margin5}>
                                <i className={"fab fa-twitter"}/>
                            </Button>
                        </ListItem>
                        <ListItem className={classes.inlineBlock}>
                            <Button justIcon link
                                    href={Dictionary.linkedin}
                                    target="_blank"
                                    className={classes.margin5}>
                                <i className={"fab fa-linkedin"}/>
                            </Button>
                        </ListItem>
                        <ListItem className={classes.inlineBlock}>
                            <Button justIcon link
                                    href={Dictionary.instagram}
                                    target="_blank"
                                    className={classes.margin5}>
                                <i className={"fab fa-instagram"}/>
                            </Button>
                        </ListItem>
                    </List>
                </div>
                <div className={classes.right}>
                    &copy; {1900 + new Date().getYear()} , made with{" "}
                    <a
                        href="https://www.creative-tim.com/product/material-kit-react"
                        className={aClasses}
                        target="_blank"
                    >
                        Material Kit React
                    </a>{" "}.
                </div>
            </div>
        </footer>
    );
}

Footer.propTypes = {
    classes: PropTypes.object.isRequired,
    whiteFont: PropTypes.bool
};

export default withStyles(footerStyle)(Footer);



// WEBPACK FOOTER //
// ./src/views/LandingPage/Sections/Footer.jsx